import {update, asyncUpdate, set, action} from "reduxigen";
import store from "../store/store";
import * as api from '../constants/API'

function processResponse(response) {
    const statusCode = response.status;
    const text = response.text();

    return Promise.all([statusCode, text]).then(res => ({
        statusCode: res[0],
        message: res[1]
    }));
}

export const resetApiResponse = set("apiResponse");

const getDoctorDetails = (value, state) => {

    let currState = store.getState();

    return fetch(process.env.API_URL + '/doctors?docID=' + value, {
        method: "GET",
    })
        .then((data) => data.json())
        .then((data) => {
            return {
                currentResult: {
                    ...currState.currentResult,
                    ...data
                }
            }
        });

};
export const loadDoctorDetails = asyncUpdate("currentResult", getDoctorDetails);

const getIframeDocsByCode = (code, state) => {
  return fetch(process.env.API_URL + '/clinicfromcode?code=' + code, {
      method: "GET",
  })
      .then((data) => data.json())
      .then((data) => {
          return {
              iframeDocs: data.doctorArray,
          }
      });
}
export const codeToClinic = asyncUpdate("iframeDocs", getIframeDocsByCode);

const getAppointmentDetails = (value, state) => {

    let currState = store.getState();

    return fetch(process.env.API_URL + '/appointmentinfos?appointmentID=' + value, {
        method: "GET",
    })
        .then((data) => data.json())
        .then((data) => {
            return {
                currentResult: data
            }
        });

};
export const loadAppointmentDetails = asyncUpdate("currentResult", getAppointmentDetails);

const reservationRequest = (body, state) => {

    return fetch(process.env.API_URL + '/appointments/reserve/gast/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: Object.keys(body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key])).join('&')
    })
        .then(processResponse)
        .then(res => {
            const {statusCode, message} = res;

            return {
                apiResponse: {
                    error: statusCode !== 200,
                    message: message
                }
            };
        });
};

export const makeReservation = asyncUpdate("apiResponse", reservationRequest);

export const loginRequest = asyncUpdate("auth", (body) => {

    return fetch(process.env.API_URL + '/auth/login', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: Object.keys(body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key])).join('&')
    })
        .then((data) => data.json())
        .then((data) => {
            if (data.token) {
                localStorage.setItem('authToken', data.token);
                localStorage.setItem('docID', data.user.doctors_id);
                return {
                    auth: {
                        authToken: data.token,
                        currentUser: data.user,
                        error: false
                    }
                };
            } else {
                return {
                    auth: {
                        authToken: null,
                        currentUser: null,
                        error: true
                    }
                };
            }
        });

});

export const createAppointment = asyncUpdate("dashboardAppointments", (body) => {

    let currState = store.getState();

    const token = localStorage.getItem('authToken');

    return fetch(process.env.API_URL + '/appointments/create', {
        method: "POST",
        withCredentials: true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + token
        },
        body: Object.keys(body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key])).join('&')
    })
        .then((data) => {
            if(data.status === 200) {
                return data.text();
            } else {
                throw "Bitte wählen Sie einen Zeitpunkt in der Zukunft.";
            }
        })
        .then((data) => {
          loadDoctorAppointments();

          return {
            apiResponse: {
              error: false,
              message: data
            }
          };
        }).catch((error) => {
            return {
                apiResponse: {
                    error: true,
                    message: 'test'
                },
            }
        });
});

export const cancelAppointment = asyncUpdate("apiResponse", (appointmentID) => {
    let currState = store.getState();

    return fetch(process.env.API_URL + '/appointments/cancel/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        },
        body: 'appointmentID=' + appointmentID
    })
        .then(processResponse)
        .then(res => {
            const {statusCode, message} = res;
            let appointments = currState.dashboardAppointments;

            if(statusCode === 200) {
                appointments = currState.dashboardAppointments.map((item) => {

                    if(item.appointments_id === appointmentID) {
                        return {
                            ...item,
                            status: 0,
                        }
                    }
                    return item;
                });
            }


            return {
                apiResponse: {
                    error: statusCode !== 200,
                    message: message
                },
                dashboardAppointments: appointments
            };

        })
        .catch(error => {
            return {
                apiResponse: {
                    error: true,
                    message: error.message
                }
            }

        })
});

export const deleteAppointment = asyncUpdate("apiResponse", (appointmentID) => {
    let currState = store.getState();

    return fetch(process.env.API_URL + '/appointments/delete/', {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        },
        body: 'appointmentID=' + appointmentID
    })
        .then(processResponse)
        .then(res => {
            const {statusCode, message} = res;
            let appointments = currState.dashboardAppointments;

            if(statusCode === 200) {
                appointments = appointments.filter(item => item.appointments_id !== appointmentID);
            }

            return {
                apiResponse: {
                    error: statusCode !== 200,
                    message: message
                },
                dashboardAppointments: appointments
            };
        }).catch(error => {
            return {
                apiResponse: {
                    error: true,
                    message: error.message
                }
            }

        });
});

export const loadUserData = asyncUpdate("auth", () => {

    return fetch(process.env.API_URL + '/auth/user', {
        method: "GET",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization: 'Bearer ' + localStorage.getItem('authToken')
        },
    })
        .then((data) => data.json())
        .then((data) => {
            return {
                auth: {
                    authToken: localStorage.getItem('authToken'),
                    currentUser: data,
                    error: false
                }
            };
        });

});

export const loadDoctorAppointments = asyncUpdate("dashboardAppointments", (starttime) => {
    if(!starttime) {
        starttime = Date.now();
    }

    return fetch(process.env.API_URL + '/appointments/doctor/?skip=0&limit=100&startdate=' + starttime, {
        method: "GET",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization: 'Bearer ' + localStorage.getItem('authToken')
        },
    })
        .then((data) => data.json())
        .then((data) => {
            return {
                dashboardAppointments: data
            };
        })
        .catch(error => {
            return {
                apiResponse: {
                    error: true,
                    message: error.message
                }
            }

        });

});


export const updateProfile = asyncUpdate("apiResponse", (body) => {

  return fetch(process.env.API_URL + '/auth/user/settings', {
    method: "POST",
    headers: {
      authorization: 'Bearer ' + localStorage.getItem('authToken')
    },
    body: body
  })
  .then((data) => {
    if(data.status === 200) {
      return data.json();
    } else {
      throw "Überprüfen Sie Ihre Angaben";
    }
  })
  .then((data) => {

    return {
      apiResponse: {
        error: false,
        message: data.doctors_id ? 'Änderungen erfolgreich gespeichert' : '',
      },
      currentResult: data,
    };
  }).catch((error) => {
    return {
      apiResponse: {
        error: true,
        message: JSON.stringify(error)
      },
    }
  });
});

export const updateLicense = asyncUpdate("apiResponse", (body) => {
  return fetch(process.env.API_URL + '/auth/user/lizenz/', {
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'Bearer ' + localStorage.getItem('authToken')
    },
    body: Object.keys(body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key])).join('&')
  })
  .then((data) => {
    if(data.status === 200) {
      return data.json()
    } else {
      throw "Überprüfen Sie Ihre Angaben";
    }
  })
  .then((data) => {

    return {
      apiResponse: {
        error: false,
        message: data
      }
    };
  }).catch((error) => {
    return {
      apiResponse: {
        error: true,
        message: JSON.stringify(error)
      },
    }
  });
});

/*
 * Body: ?oldpwd=&newpwd=
 */

export const updatePassword = asyncUpdate("apiResponse", (body) => {
  return fetch(process.env.API_URL + '/auth/user/resetpassword/', {
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'Bearer ' + localStorage.getItem('authToken')
    },
    body: Object.keys(body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key])).join('&')
  })
  .then((data) => {
    if(data.status === 200) {
      return data.json();
    } else {
      throw "Überprüfen Sie Ihre Angaben";
    }
  })
  .then((data) => {

    return {
      apiResponse: {
        error: false,
        message: data.msg
      }
    };
  }).catch((error) => {
    return {
      apiResponse: {
        error: true,
        message: error
      },
    }
  });
})

export const sendContactMessage = asyncUpdate("apiResponse", (body) => {
  return fetch(process.env.API_URL + '/contact/', {
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: Object.keys(body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key])).join('&')
  })
  .then((data) => {
    if(data.status === 200) {
      return data.text();
    } else {
      throw "Überprüfen Sie Ihre Angaben";
    }
  })
  .then((data) => {

    return {
      apiResponse: {
        error: false,
        message: data
      }
    };
  }).catch((error) => {
    return {
      apiResponse: {
        error: true,
        message: JSON.stringify(error)
      },
    }
  });
});

export const registerRequest = asyncUpdate("apiResponse", (body) => {
  return fetch(process.env.API_URL + '/auth/register', {
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: Object.keys(body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key])).join('&')
  })
  .then((data) => {
    if(data.status === 200) {
      return data.json();
    } else {
      throw "Es ist ein Fehler aufgetreten.";
    }
  })
  .then((data) => {

    return {
      apiResponse: {
        error: false,
        message: data.msg
      }
    };
  }).catch((error) => {
    return {
      apiResponse: {
        error: true,
        message: error
      },
    }
  });
});



// WEBPACK FOOTER //
// ./src/actions/ApiActions.js